import router from '../routes'

export const handleCommonResponseErrors = (err) => {

  // non 200 status code
  if (err.response) {

    if (err.response.status === 403) {
      router.push({name: 'forbidden'})
    }

    if (err.response.status === 404) {
      router.push({name: 'not-found'})
    }

    if (err.response.status === 500) {
      router.push({name: 'whoops'})
    }

  // no response from server
  } else if (err.request) {
    router.push({name: 'no-response'})

  // request not set up properly
  } else {
    router.push({name: 'whoops'})
  }
}



// WEBPACK FOOTER //
// ./src/api/handle-errors.js